import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useLoadedImage } from '../../hooks/useLoadedImage';
import { AvatarPartButton } from './avatarPartButton';
const DEFAULT_SCALE = 0.5;
export const AvatarPartImageButton = ({ imageUrl, isSelected, title, scale = DEFAULT_SCALE, onClick }) => {
    const loadedImage = useLoadedImage(imageUrl);
    if (!loadedImage) {
        return null;
    }
    const width = Math.round(loadedImage.width * scale);
    const height = Math.round(loadedImage.height * scale);
    return (_jsx(AvatarPartButton, { onClick: onClick, isSelected: isSelected, children: _jsx("img", { width: width, height: height, src: imageUrl, title: title }) }));
};
